import React from 'react';
import { EventContentArg } from '@fullcalendar/core';
import { Utility } from 'helpers/UtilityHelpers';
import { Code   } from 'constants/codes';

interface EventContentProps {
  arg: EventContentArg;
}

const EventContent: React.FC<EventContentProps> = ({ arg }) => {
  return (
    <div className="fc-event-content">
      <b>{arg.event.title}</b>
      <span>{arg.event.extendedProps.typeName}</span>
      <p>
        {Utility.Format.Date(arg.event.start!, Code.Format.DateTime.TimeTT)} -{' '}
        {Utility.Format.Date(arg.event.end!, Code.Format.DateTime.TimeTT)}
      </p>
    </div>
  );
};



export const CalendarManager = {
  Event:{
    Content: EventContent,
  }
}
